import React, {Fragment} from 'react';
import {connect} from "react-redux";
import Table from "../../../components/Table";
import {globals} from "../../../../../common/constants";
import {
    addPatient,
    deletePatient,
    editPatient,
    getCase, getParentCases,
    getPatient,
} from "./Home/actions";
import ReactTooltip from "react-tooltip";
import ModalComponent from "../../../components/Modal";
import CustomModalBody from "../../../components/Patient/CustomModalBody";
import Notice from "../../../components/Notification/newNotification";
import {useDashboardEventList} from "../CustomHooks";
import {scrollTo} from "../../../helpers";

class UserPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deletePatientModal: false,
            dropRowId:null,
            deleteInProgress: false,
            searchText: '',
            sortingOptions: {
                field: 'id',
                type: 'ASC'
            },
            tableOption: {
                noDataText: 'No patient is available yet.',
                hideSizePerPage: true,
                onRowClick: (row) => this.linkToCasesPage(row),
                sizePerPage: 2,
                page: this.props.locationState ? this.props.locationState.pageNumber : 1,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
                onPageChange: (page) => this.handlePageChange(page)
            },
            newPatient: {
                first_name: '',
                last_name: '',
                notes: ''
            },
            validateNewPatient: {
                first_name: true,
                last_name: true
            },
            implantsPartObject: {
                1: { name: 'Impression coping ', number: 0 },
                2: { name: 'Impression screw ', number: 0 },
                3: { name: 'Lab analog ', number: 0 },
                4: { name: 'Prosthetic screw ', number: 0 },
                5: { name: 'Abutment/Ti', number: 0 },
                6: { name: 'Other ', number: 0 }
            },
            enclosedBoxObject: {
                1: { name: 'Impression/master model' },
                2: { name: 'Antagonist model/impression' },
                3: { name: 'Bite' },
                4: { name: 'Pre-op/temp model/impression' },
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
        }
    }


    componentDidMount() {
        if (this.props.home.added) {
            Notice.addNotification('Patient is successfully added.', 'success');
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (!this.props.home.patientList.dentist && nextProps.home.patientList.dentist) {
            this.setState({
                run: (nextProps.home.patientList.dentist.guide ? !nextProps.home.patientList.dentist.subcase_onboarded : !nextProps.home.patientList.dentist.guide),
            })
        }
        if (!this.props.home.editGuide && nextProps.home.editGuide) {
            this.setState({ run: false, isOpenStartTour: false });
            const { startOfCalendarView, endOfCalendarView } = this.state;
        }
        if (this.state.selectedDateKey !== undefined) {
            const selectDate = this.state.selectedDateKey;
            if (nextProps.home.patientList.numberOfUnits[selectDate] !== undefined) this.setState({ numberOfUnitsForPerDay: nextProps.home.patientList.numberOfUnits[selectDate].units });
        }

        if (nextProps.isPatientDeleted && this.state.deleteInProgress) {
            Notice.addNotification('Patient is successfully deleted.', 'success');
            this.setState({ deletePatientModal: false, deleteInProgress: false })
        }

        if (nextProps.home.addBookingRequest === true) {
            Notice.addNotification('Booking is added successfully.', 'success');
            const { startOfCalendarView, endOfCalendarView } = this.state;
            // this.props.getPatient({ startOfCalendarView, endOfCalendarView });
            this.props.getCase(nextProps.home.addedData);
            this.setState({
                addBookingShow: false,
                moreThenAvailableUnitsModal: false,
                printModal: true,
                modalHeaderText: 'Print Booking',
                modalBodyText: 'Would you like to print the case?',
                addingBookingInfo: {
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: []
                },
                isOpenSubcaseForm: false,
                validationBooking: { patient_id: false, number_of_units: false, type: false, implant: false, sending_date: false, enclosedBox: false }
            });
        } else if (nextProps.home.editPatient === false) {
            //Notice.addNotification('Your session is expired.', 'error');
            this.setState({ editPatientModal: false })
        } else if(nextProps.home.added){
            this.setState({ addNewPatient: false, addBookingShow: this.state.openBookingFormAfterAddNewPatient, newPatient: { first_name: '', last_name: '', notes: '' }, validateNewPatient: { first_name: true, last_name: true }, addingBookingInfo: { ...this.state.addingBookingInfo, patient_id: nextProps.home.patientList.newPatient.id } })
        } else if (nextProps.home.editPatient) {
            //Notice.addNotification('Patient is successfully edited.', 'success');
            this.setState({ editPatientModal: false })
        } else if (nextProps.home.pickupScheduled) {
            this.setState({ isOpenPickupModal: false });
        }
        if (nextProps.home.gotCaseDetails && !this.props.home.gotCaseDetails && this.state.addingBookingInfo && this.state.addingBookingInfo.parent_id && !this.state.printModal) {
            this.setState({ isOpenSubcaseForm: true, createSubcaseModal: false });
        }
        if(nextProps.home.patientList.events !== this.props.home.patientList.events) {
            this.eventList = useDashboardEventList(nextProps.home.patientList.events);
        }

        if(nextProps.isPatientDeleted === false && nextProps.validationMessage) {
            Notice.addNotification(nextProps.validationMessage, 'error');
            this.setState({ deleteInProgress: false })
        }
    }

    handlePageChange = (page) => {
        scrollTo(0, 'smooth');
        this.setState({
            tableOption: {
                ...this.state,
                page
            }
        }, () => {
            const {startOfCalendarView, endOfCalendarView} = this.state;
            this.props.getPatient({page, startOfCalendarView, endOfCalendarView});
        });
    }

    addNewPatient = (guide) => {
        if (!guide) {
            return false;
        }
        if (this.state.addBookingShow) {
            this.setState({ addNewPatient: true, openBookingFormAfterAddNewPatient: true, addBookingShow: false })
        } else {
            this.setState({ addNewPatient: true })
        }
    }

    handleAddNewPatient = () => {
        const { newPatient, startOfCalendarView, endOfCalendarView } = this.state;
        const first_name = !!newPatient.first_name;
        const last_name = !!newPatient.last_name;
        newPatient.startDate = this.state.startOfCalendarView;
        newPatient.endDate = this.state.endOfCalendarView;
        if (!first_name || !last_name) {
            this.setState({ validateNewPatient: { first_name: first_name, last_name: last_name } })
        } else {
            this.props.addPatient({ ...newPatient, startDate: startOfCalendarView, endDate: endOfCalendarView });
        }
    }

    onSearchChange = (event) => {
        this.setState({searchText: event.target.value});
        this.eventList = [];
    }

    get patientList() {
        const searchText = this.state.searchText.trim().toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return this.props.home.patientList.patients ? this.props.home.patientList.patients.filter(patient => {
            return patient.id.toString().indexOf(searchText) === 0 || patient.fullName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(searchText) === 0 ||  patient.fullName.split(' ').some(item => item.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(searchText) === 0)
        }).sort((a, b) => {
            const { type, field } = this.state.sortingOptions;
            if (type === 'ASC') {
                return a[field] - b[field];
            }
            return b[field] - a[field];
        }) : [];
    }

    handleSort = (field, type) => {
        this.setState({ sortingOptions: { field, type } });
    }

    openTableRow = (cell) => {
        if(cell === this.state.dropRowId){
            this.setState({dropRowId:null})
        } else {
            this.setState({dropRowId:cell})
        }
    }

    idFormatter = (cell) => {
        const hasEventList = this.props.home.patientList.events.some(item => item.patientId === cell)
        if(hasEventList){
            return (
                <div
                    className={`id_col ${cell === this.state.dropRowId ? 'active-row' : ''}`}
                    onClick={() => this.openTableRow(cell)}
                >
                    <span className="kr kr-arrow" />
                    <span>{cell}</span>
                </div>
            )
        }else {
            return (
                <div
                    className={`id_col ${cell === this.state.dropRowId ? 'active-row' : ''}`}
                >
                    <span className='patient_id_cell'>{cell}</span>
                </div>
            )
        }
    }

    caseIdFormatter = (cell) =>{
        return (
            <div>
                {this.state.dropRowId === cell &&
                <div className="drop-cases">
                    {
                        this.props.home.patientList.events.map((item)=>{
                            if(cell === item.patientId){
                                return <div className="drop-cases__item" key={item.caseId}>
                                    <Fragment>
                                        <div className="drop-cases__id">CASE {item.caseId}</div>
                                        <div className="drop-cases__status">{item.status}</div>
                                    </Fragment>
                                </div>
                            }
                        })
                    }
                </div>
                }
            </div>
        )
    }

    getPatientById(patientId) {
        let patient = undefined;
        this.patientList.map((item) => {
            if (item.id === patientId) {
                return patient = item;
            } else {
                return false;
            }
        });
        return patient;
    }

    editPatient(event, patientId) {
        if (this.state.editPatientModal) {
            const first_name = !!(this.state.editPatientInfo.first_name);
            const last_name = !!(this.state.editPatientInfo.last_name);
            if (!first_name || !last_name) {
                this.setState({
                    validateNewPatient: {
                        first_name: first_name,
                        last_name: last_name,
                    }
                })
            } else {
                this.props.editPatientData({
                    ...this.state.editPatientInfo,
                });
            }
        } else {
            const patient = this.getPatientById(patientId);
            this.setState({
                editPatientModal: true,
                editPatiientId: patientId,
                editPatientInfo: patient,
            });
        }
        event.stopPropagation();
    }

    deletePatient(event, patientId) {
        const startDate = this.state.startOfCalendarView;
        const endDate = this.state.endOfCalendarView;
        this.props.deletePatient(patientId, { startDate, endDate });
        this.setState({
            deletePatientModal: true,
            deleteInProgress: true
        });
        event.stopPropagation();
    }

    fullNameFormatter = (row, cell) => {
        return (
            <div className="patient-name">
                {cell.fullName}
            </div>
        )
    }

    actionsFormatter = (row, cell) => {
        const patientId = cell.id;
        return (
            <div className="user-actions">
                    <span
                        data-tip="Edit"
                        className="kr kr-edit"
                        onClick={(event) => this.editPatient(event, patientId)}
                    />
                <span
                    data-tip="Delete"
                    className="kr kr-delete"
                    onClick={(event) => this.deletePatient(event, patientId)}
                />
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
        )
    }

    handelChange = (key, value) => {
        this.setState(prevState => ({
            newPatient: {
                ...prevState.newPatient,
                [key]: value
            },
            validateNewPatient: {
                ...prevState.validateNewPatient,
                [key]:value,
            }
        }))
    }

    handleClose() {
        if (!this.state.isOpenLeaveModal && this.state.addBookingShow && !this.state.printModal && (this.props.home.patientList.dentist.guide && !this.state.isOpenStartTour)) {
            this.setState({ isOpenLeaveModal: !this.state.isOpenLeaveModal });
        } else if (this.state.printModal) {
            this.setState({ isOpenPickupModal: true, printModal: false });
        } else {
            this.setState({
                addBookingShow: this.state.openBookingFormAfterAddNewPatient,
                printModal: false,
                openBookingFormAfterAddNewPatient: false,
                addNewPatient: false, cancelModal: false,
                moreThenAvailableUnitsModal: false,
                deletePatientModal: false,
                editPatientModal: false,
                validateNewPatient: { first_name: true, last_name: true },
                validationBooking: {
                    dentist_id: false,
                    patient_id: false,
                    sending_date: false,
                    number_of_units: false,
                    type: false,
                    implant: false,
                    enclosedBox: false
                },
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    sending_date: null,
                    image: [],
                },
                isOpenLeaveModal: false,
                isOpenStartTour: false,
                createSubcaseModal: false
            });
        }
    }

    handleChangeEdit(key, value) {
        this.setState(prevState => ({
            editPatientInfo: {
                ...prevState.editPatientInfo,
                [key]: value
            }
        }))
    }

    render() {
        return (
            <div className="patient-list">
                <h3 className="patient-list__title">MY PATIENTS</h3>
                <div className="patient-list__actions">
                    <input className="search-form"
                           type="text"
                           placeholder="Search"
                           value={this.state.searchText}
                           onChange={this.onSearchChange}
                    />
                    <button
                        className="btn btn-secondary new_patient_btn"
                        onClick={() => this.addNewPatient(true)}
                    >
                        <span className="kr kr-plus"/>
                        New Patient
                    </button>
                </div>
                <Table
                    className='patient-table'
                    dropDown={true}
                    dropRowId={this.state.dropRowId}
                    dropDownCol={
                        [
                            {
                                name: '',
                                key: 'id',
                                render: (cell,row) => this.caseIdFormatter(cell,row),
                                isSortable: true,
                                isFilterable: false,
                                filterType: 'string'
                            }
                        ]
                    }
                    patientId={this.state.patientId}
                    totalNumber={this.props.home.patientList && this.props.home.patientList.patients && this.props.home.patientList.patients.length}
                    columns={[
                        {name: 'ID', key: 'id', render: (cell, row) => this.idFormatter(cell, row), isSortable: true, isFilterable: false, filterType: 'number' },
                        {name: 'Full Name', key: 'id', render: (cell, row) => this.fullNameFormatter(cell, row), isSortable: true, isFilterable: false, filterType: 'string' },
                        {name: 'Actions', key: 'id', render: (cell, row) => this.actionsFormatter(cell, row), isSortable: false, isFilterable: false, filterType: 'string' }
                    ]}
                    columnShow={this.props.home.tableConfigDentist}
                    isAdmin={false}
                    data={this.patientList.slice((this.state.tableOption.page - 1)*globals.adminPatientsPerPage,this.state.tableOption.page*globals.adminPatientsPerPage )}
                    filterOptions={this.state.filterOptions}
                    handleFilterDataChange={this.handleFilterDataChange}
                    handlePageChange={this.handlePageChange}
                    currentPage={this.state.tableOption.page}
                    isHeaderHidden={false}
                    pagination={true}
                    getFilteredDataRequest={this.getFilteredDataRequest}
                    sortingOptions={this.state.sortingOptions}
                    handleSort={this.handleSort}
                />
                {
                    this.state.addNewPatient &&
                    <ModalComponent
                        dialogClassName="profile__modals"
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle="Add New Patient"
                        modalBody={<CustomModalBody handelChange={(key, value) => this.handelChange(key, value)} validation={this.state.validateNewPatient} />}
                        show={this.state.addNewPatient}
                        handleClose={() => this.handleClose()}
                        buttonText="Add"
                        buttonDisabled={this.props.loadingPatient}
                        buttonFunction={() =>  this.handleAddNewPatient()}
                    />
                }
                {
                    this.state.editPatientModal &&
                    <ModalComponent
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle="Edit Patient"
                        modalBody={
                            <CustomModalBody
                                editPatientInfo={this.state.editPatientInfo}
                                handelChange={(key, value) => this.handleChangeEdit(key, value)}
                                validation={this.state.validateNewPatient}
                            />
                        }
                        show={this.state.editPatientModal}
                        handleClose={() => this.handleClose()}
                        buttonText="Save"
                        buttonFunction={(event) => this.editPatient(event, this.state.editPatiientId)}
                    />
                }
            </div>

        )
    }
}

const mapStateToProps = dispatch => {
    return {
        loadingPatient: dispatch.home.loadingPatient,
        home: dispatch.home,
        caseDetails: dispatch.caseDetails,
        isPatientDeleted: dispatch.home.deletePatient,
        validationMessage: dispatch.home.validationMessage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPatient: (data) => { dispatch(addPatient(data)); },
        //addBooking: (data) => { dispatch(addBooking(data)); },
        getPatient: (data) => { dispatch(getPatient(data)); },
        deletePatient: (patientId, data) => { dispatch(deletePatient(patientId, data)); },
        editPatientData: (data) => {
            dispatch(editPatient(data)); },
        //updateGuide: () => { dispatch(updateGuide()); },
        getCase: (caseId) => { dispatch(getCase(caseId)); },
        //addPickup: (caseId, isPickup) => { dispatch(addPickup(caseId, isPickup)); },
        getParentCases: () => { dispatch(getParentCases()); },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/PatientsTable.js